import clsx from 'clsx';
import PropTypes from 'prop-types';

//lib
import { INSTAGRAM } from '@/lib/socialProfile';
import { IG_POST_TYPES, getPostType, POST } from '@/lib/posts/postTypes';
import { DEFAULT_POST_CONFIG } from '@/lib/posts/defaultPostConfig';

//components
import Post from '@/components/base/Post';
import HoverLabelAndAlbums from '@/components/base/Post/HoverLabelAndAlbums';

const InstagramPost = ({
    data,
    isLoading,
    config,
    openViewer,
    handleLabelsEvent,
    handleAlbumsEvent,
    postConfig = DEFAULT_POST_CONFIG,
    remoteMedia = false,
    feedType = null,
    isExport = false,
    ...restProps
}) => {
    const mergedPostConfig = { ...DEFAULT_POST_CONFIG, ...postConfig };
    const type = getPostType({ network: INSTAGRAM, type: data?.type });

    if (isLoading) {
        return <Post.Placeholder postType={POST} isExport={isExport} />;
    }

    return (
        <div className="w-full">
            <Post.Header data={data} isExport={isExport} />
            <Post
                data={data}
                config={config}
                isLoading={isLoading}
                className={clsx('w-full bg-white', {
                    'p-2': !mergedPostConfig?.hasFooter && mergedPostConfig?.hasHover,
                    'p-0.5': !mergedPostConfig?.hasFooter && !mergedPostConfig?.hasHover,
                    'px-2 pt-2': mergedPostConfig?.hasFooter,
                    'dark:bg-icoDarkMode-anthracite': !isExport
                })}
                isExport={isExport}
                {...restProps}>
                {({ referenceElement }) => (
                    <>
                        <Post.Content className="w-full">
                            {mergedPostConfig?.hasHover ? (
                                <HoverLabelAndAlbums
                                    openViewer={openViewer}
                                    referenceElement={referenceElement}
                                    handleLabelsEvent={handleLabelsEvent}
                                    handleAlbumsEvent={handleAlbumsEvent}
                                    showLabels={mergedPostConfig?.showLabels}
                                    showAlbums={mergedPostConfig?.showAlbums}
                                    socialProfile={data?.social_profile}
                                />
                            ) : null}
                            {type && type !== IG_POST_TYPES.TYPE_PHOTO ? (
                                <Post.PostTypeIcon type={type} isExport={isExport} />
                            ) : null}
                            <div className="absolute left-1 top-1 flex flex-col space-y-1.5">
                                {data?.promoted_post ? <Post.Promoted /> : null}
                                {data?.has_collaborators ? <Post.Collaborators /> : null}
                            </div>
                            <div className="square">
                                <Post.Image remoteMedia={remoteMedia} />
                            </div>
                        </Post.Content>
                        {mergedPostConfig?.hasFooter ? (
                            <Post.Footer feedType={feedType} type={type} />
                        ) : null}
                    </>
                )}
            </Post>
        </div>
    );
};

InstagramPost.propTypes = {
    data: PropTypes.object,
    isLoading: PropTypes.bool,
    config: PropTypes.object,
    openViewer: PropTypes.func,
    addLabel: PropTypes.func,
    addAlbum: PropTypes.func
};

export default InstagramPost;
